import { css, jsx } from '@emotion/core';
import React from 'react';

import { bp } from '@/styles';

import Step from './components/Step';

const StepIndicator = ({ step, changeCurrentStep }) => {
  const styles = {
    stepContainer: css`
      margin: 0;
      display: flex;
      flex-wrap: wrap;
      @media ${bp.md} {
        margin: 2.4rem;
        flex-wrap: nowrap;
      }
    `,
  };

  return (
    <div css={styles.stepContainer}>
      <Step
        currentStep={step}
        totalNumberOfSteps={3}
        index={0}
        title="Step 1"
        last={false}
        description="Personal Info"
      />
      <Step
        currentStep={step}
        totalNumberOfSteps={3}
        index={1}
        title="Step 2"
        last={false}
        description="Company Info"
      />
      <Step
        currentStep={step}
        totalNumberOfSteps={3}
        index={2}
        last
        title="Step 3"
        description="Email & Password"
      />
    </div>
  );
};

export default StepIndicator;
